import { render, staticRenderFns } from "./_Section2.vue?vue&type=template&id=06828900&"
import script from "./_Section2.vue?vue&type=script&lang=js&"
export * from "./_Section2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports